import React from 'react'
import "../../Assets/css/mobile-app.css";
import { Col, Container, Image, Row } from 'react-bootstrap';
import b2bapp from "../../Assets/images/b2b-app.png";
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

const MobileApp = () => {
    return (
        <section className='mobile-app-wrapper'>
            <Container>
                <Row>
                    <Col xs={12}>
                        <div className='mobileapp-wrap text-center'>
                            <div class="mobile-heading-sec">
                                <p className='mobile-subhead'>Powering Your Growth with</p>
                                <h2>B2B App Development</h2>
                            </div>
                            <Image src={b2bapp} className='img-fluid' alt='B2B APP' />
                            <p className='mobile-description'>Introducing our B2B Mobile App – designed exclusively for the jewelry industry. Streamline your operations with real-time inventory, custom orders, and seamless vendor communication.</p>
                            <div className="bw_btb_border_white btn_view_more text-center">
                                <NavLink
                                    to="/contacts" 
                                    className="text-decoration-none bw_custom_btn"
                                >
                                    Contact Us
                                </NavLink>
                            </div> 
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default MobileApp 